import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HqRouteService } from './hq-route.service';
import { LocalStorageService } from './localStorage.service';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root',
})
export class TokenLoginService {
  constructor(
    private _localStorage: LocalStorageService,
    private _hqRouteService: HqRouteService,
    private _apiService: ApiService,
    private _messageService: MessageService
  ) {}

  // get HQ details by HQ ID
  getHQTokenAccessDetails(hq_id) {
    this._apiService.getHQAccessDetails(hq_id).subscribe(
      (response) => {
        if (response.statusCode === 200) {
          if (
            response.data.role === 'rest_hq_admin' ||
            response.data.role === 'rest_hq_staff'
          ) {
            this.setHQUserDataOnLocalStorage(response.data, '');
            this._hqRouteService.postLogin(response.data.permissions);
            this._messageService.showSuccess('Login successful');
          } else {
            this._messageService.showError('Invalid User');
          }
        }
      },
      (error) => {
        this._messageService.showError('Invalid User');
      }
    );
  }

  // Setting up HQ user data in localstorage
  setHQUserDataOnLocalStorage(userData, userEmail = '') {
    localStorage.setItem('token', userData.token);
    localStorage.setItem('email', userEmail);
    localStorage.setItem('user_type', 'MM');
    localStorage.setItem('restaurant_name', userData.mall_name);
    localStorage.setItem('hq_id', userData.hq_id);
    localStorage.setItem('staff_user_id', userData.user_id);
    localStorage.setItem('is_admin', '0');
    localStorage.setItem('ee_theme', 'dark');
    localStorage.setItem('ee_user_type', userData.role);
    const restaurantsWithoutKiosk = userData?.mall_restaurants?.filter(
      (restaurant) => restaurant?.settings?.global?.is_kiosk !== 1
    );
    const restaurantsWithKiosk = userData?.mall_restaurants;
    localStorage.setItem('staff_centre_outlets', JSON.stringify(restaurantsWithKiosk));
    localStorage.setItem('ee_outlets', JSON.stringify(restaurantsWithoutKiosk)); 
    localStorage.setItem('ee_mall_name', userData.mall || userData.mall_name);
    this._localStorage.set(
      'user_permissions',
      JSON.stringify(userData.permissions)
    );
    this._localStorage.set(
      'restaurant_id',
      (userData.mall_restaurants[0] || {}).id
    );
    (userData.user_details || {}).hq_settings &&
      this._localStorage.set(
        'hq_settings',
        JSON.stringify((userData.user_details || {}).hq_settings)
      );
    this._localStorage.set('hq_logo', userData.logo || '');
    this.syncSaasCompanyId(userData.hq_id);
  }

  private syncSaasCompanyId(hqId: string): void {
    if (!hqId) {
      return;
    }
    this._apiService.getRestaurantHq(hqId).subscribe(
      (response) => {
        const saasCompanyId = response?.data?.saas_company_id;
        if (saasCompanyId) {
          this._localStorage.set('saas_company_id', saasCompanyId);
        } else {
          this._localStorage.remove('saas_company_id');
        }
      },
      () => {}
    );
  }
}
